<script setup lang="ts">
import { computed } from "vue"
import { useColorMode } from "@vueuse/core"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/composables/useFlash"
import "vue-sonner/style.css"

const colorMode = useColorMode()
const theme = computed(() => (colorMode.value === "dark" ? "dark" : "light"))

useFlash()
</script>

<template>
  <slot />
  <Toaster
    rich-colors
    position="bottom-right"
    :theme="theme"
    expand
    close-button
    :swipe-directions="[]"
  />
</template>
